import React, { useEffect } from "react";
import $ from 'jquery';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import { currentDate } from "../../../common/commonFun";

const SupportHcpEnterBaselineDataModal = ({ isShowing, hide }) => {
  useEffect(() => {
    if (isShowing) {
      document.body.classList.add("modal-open");
      
      setTimeout(() => {
        $('#dateStartedTreatment').datepicker({
          format: 'dd/mm/yyyy',
          startView: 2,
          startDate: '01/01/1900',
          endDate: currentDate(),
          autoclose: true,
        });
      }, 100);
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isShowing]);

  if (!isShowing) return null;

  return (
    <>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", overflowY: "auto" }}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: '950px' }}>
          <div className="modal-content border-0 rounded-3 shadow-lg" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header border-bottom px-4 pt-4 pb-3">
              <div>
                <h2 className="fw-bold fs-3 mb-1 text-teal">
                  ENTER BASELINE DATA
                </h2>
                <p className="mb-0 text-secondary fs-14">
                  Example fields to demonstrate capture of clinical markers, patient-reported outcomes and healthcare utilisation.
                </p>
              </div>
              <button
                type="button"
                className="btn-close ms-auto align-self-start mt-2 me-2"
                aria-label="Close"
                onClick={hide}
              ></button>
            </div>
            
            <div className="modal-body px-4 py-4" style={{ overflowY: 'auto' }}>
              {/* Section 1 */}
              <div className="mb-4 pb-2">
                <div className="d-flex align-items-center mb-3">
                  {/* <svg width="26" height="26" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#2d9b9f" fill="none" strokeLinecap="round" strokeLinejoin="round" className="me-2">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1" />
                    <path d="M8 15a6 6 0 1 0 12 0v-3" />
                    <path d="M11 3v2" />
                    <path d="M6 3v2" />
                    <circle cx="20" cy="10" r="2" />
                  </svg> */}
                  <div className="d-flex align-items-baseline mt-1">
                    <h5 className="mb-0 fw-bold fs-16 text-uppercase text-teal me-2">
                      CLINICAL INFORMATION
                    </h5>
                    <span className="text-secondary fs-14">(Completed by HCP)</span>
                  </div>
                </div>
                <div className="row g-3 mb-3 align-items-end">
                  <div className="col-md-4">
                    <label className="form-label fw-bold fs-14">Diagnosis</label>
                    <select className="form-select fs-14">
                      <option>Select or enter diagnosis</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-bold fs-14">Disease severity</label>
                    <select className="form-select fs-14">
                      <option>Select</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-bold fs-14">Date started treatment</label>
                    <input type="text" className="form-control fs-14" id="dateStartedTreatment" placeholder="dd/mm/yyyy" readOnly />
                  </div>
                </div>
                <div className="row g-3 align-items-end">
                  <div className="col-12 mb-0 pb-0">
                    <div className="d-flex align-items-baseline mb-0">
                      <label className="form-label fw-bold fs-14 mb-0 me-1">Key biomarker</label>
                      <span className="text-secondary fs-14 fw-normal">(as applicable)</span>
                    </div>
                  </div>
                  <div className="col-md-5 mt-1">
                    <input type="text" className="form-control fs-14" placeholder="Biomarker name" />
                    
                  </div>
                  <div className="col-md-5 mt-1">
                    <input type="text" className="form-control fs-14" placeholder="Value + units" />
                  </div>
                  <div className="col-md-5 mt-1">
                    <div className="form-text mt-1 text-secondary fs-12">e.g. Biomarker, lab value</div>
                  </div>
                </div>
              </div>

              <hr className="text-secondary opacity-25 my-4" />

              {/* Section 2 */}
              <div className="mb-4">
                <div className="d-flex align-items-center mb-4">
                  {/* <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2d9b9f" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="me-2">
                    <circle cx="12" cy="7" r="4" />
                    <path d="M4 21v-1a8 8 0 0 1 16 0v1" />
                  </svg> */}
                  <div className="d-flex align-items-baseline mt-1">
                    <h5 className="mb-0 fw-bold fs-16 text-uppercase text-teal me-2">
                      PATIENT-REPORTED OUTCOMES (PRO<span className="small">s</span>)
                    </h5>
                    <span className="text-secondary fs-14">(Completed by patient)</span>
                  </div>
                </div>
                <div className="row g-4 mb-4">
                  <div className="col-md-4 position-relative">
                    <div className="pe-md-3">
                      <label className="form-label fw-bold fs-14 d-block mb-1">Overall health today</label>
                      <div className="d-flex justify-content-between text-secondary fs-12 mb-2">
                        <span className="text-nowrap">0 = Worst health</span>
                        <span className="text-nowrap">10 = Best health</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <span className="fw-bold fs-14 pe-2">0</span>
                        <input type="range" className="form-range" min="0" max="10" defaultValue="5" />
                        <span className="fw-bold fs-14 ps-2">10</span>
                      </div>
                      <div className="text-center">
                        <input type="text" className="form-control text-center d-inline-block fs-14" style={{ width: "80px" }} placeholder="/10" />
                      </div>
                    </div>
                    <div className="d-none d-md-block position-absolute end-0 top-0 h-100 border-end" style={{ width: '1px' }}></div>
                  </div>
                  
                  <div className="col-md-4 position-relative">
                    <div className="px-md-2">
                      <label className="form-label fw-bold fs-14 d-block mb-1">Symptom burden</label>
                      <div className="d-flex justify-content-between text-secondary fs-12 mb-2">
                        <span className="text-nowrap">0 = No impact</span>
                        <span className="text-nowrap">10 = Extreme impact</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <span className="fw-bold fs-14 pe-2">0</span>
                        <input type="range" className="form-range" min="0" max="10" defaultValue="5" />
                        <span className="fw-bold fs-14 ps-2">10</span>
                      </div>
                      <div className="text-center">
                        <input type="text" className="form-control text-center d-inline-block fs-14" style={{ width: "80px" }} placeholder="/10" />
                      </div>
                    </div>
                    <div className="d-none d-md-block position-absolute end-0 top-0 h-100 border-end" style={{ width: '1px' }}></div>
                  </div>

                  <div className="col-md-4">
                    <div className="ps-md-3">
                      <label className="form-label fw-bold fs-14 d-block mb-1">Fatigue</label>
                      <div className="d-flex justify-content-between text-secondary fs-12 mb-2">
                        <span className="text-nowrap">0 = No fatigue</span>
                        <span className="text-nowrap">10 = Extreme fatigue</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <span className="fw-bold fs-14 pe-2">0</span>
                        <input type="range" className="form-range" min="0" max="10" defaultValue="5" />
                        <span className="fw-bold fs-14 ps-2">10</span>
                      </div>
                      <div className="text-center">
                        <input type="text" className="form-control text-center d-inline-block fs-14" style={{ width: "80px" }} placeholder="/10" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="rounded-3 p-3 mt-4 mx-1" style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef" }}>
                  <div className="row align-items-center">
                    <div className="col-md-6 border-end-md py-2">
                      <div className="d-flex align-items-baseline mb-2">
                        <h6 className="fw-bold fs-14 mb-0 text-teal me-1">PROs summary score</h6>
                        <span className="text-secondary fs-12 fw-normal">(auto-calculated)</span>
                      </div>
                      <div className="d-flex align-items-center mt-3">
                        <div className="d-flex align-items-baseline me-3">
                          <span className="fw-bold fs-14 me-1">Total score</span>
                          <span className="text-secondary fs-14 fw-normal">(0-30)</span>
                        </div>
                        <input type="text" className="form-control text-center bg-white fs-14 ms-auto " style={{ width: "80px", marginRight: "10.5rem" }} placeholder="/30" readOnly />
                      </div>
                    </div>
                    <div className="col-md-6 ps-md-5 mt-3 mt-md-0 d-flex align-items-center">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2d9b9f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2 flex-shrink-0">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="16" x2="12" y2="12" />
                        <line x1="12" y1="8" x2="12.01" y2="8" />
                      </svg>
                      <span className="fs-14 text-secondary">Lower score = greater burden</span>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="text-secondary opacity-25 my-4" />

              {/* Section 3 */}
              <div className="mb-2">
                <div className="d-flex align-items-center mb-3">
                  {/* <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2d9b9f" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="me-2">
                    <path d="M3 21h18" />
                    <path d="M5 21v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14" />
                    <path d="M5 13h14" />
                    <path d="M10 21v-5h4v5" />
                    <path d="M10 9h4" />
                    <path d="M12 7v4" />
                    <path d="M9 16h.01" />
                    <path d="M15 16h.01" />
                    <path d="M9 18h.01" />
                    <path d="M15 18h.01" />
                  </svg> */}
                  <div className="d-flex align-items-baseline mt-1">
                    <h5 className="mb-0 fw-bold fs-16 text-uppercase text-teal me-2">
                      HEALTHCARE RESOURCE UTILISATION
                    </h5>
                    <span className="text-secondary fs-14">(Completed by HCP)</span>
                  </div>
                </div>
                <div className="row g-3 align-items-end">
                  <div className="col-md-4">
                    <div className="d-flex align-items-baseline mb-1">
                      <label className="form-label fw-bold fs-14 mb-0 me-1">ER visits</label>
                      <span className="text-secondary fs-14 fw-normal">(past 12 months)</span>
                    </div>
                    <input type="text" className="form-control fs-14 mb-1" placeholder="Enter number" />
                    <div className="form-text text-secondary fs-12 mt-1">If unknown, leave blank.</div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-baseline mb-1">
                      <label className="form-label fw-bold fs-14 mb-0 me-1">Hospitalisations</label>
                      <span className="text-secondary fs-14 fw-normal">(past 12 months)</span>
                    </div>
                    <input type="text" className="form-control fs-14 mb-1" placeholder="Enter number" />
                    <div className="form-text text-secondary fs-12 mt-1">If unknown, leave blank.</div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-baseline mb-1">
                      <label className="form-label fw-bold fs-14 mb-0 me-1">Other relevant health service use</label>
                      <span className="text-secondary fs-14 fw-normal">(optional)</span>
                    </div>
                    <input type="text" className="form-control fs-14" placeholder="Enter details" />
                    <div className="form-text text-secondary fs-12 mt-1" style={{ visibility: "hidden" }}>Placeholder</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer border-top pt-3 pb-4 px-4 bg-white rounded-bottom border-0">
              <div className="baseline-modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-teal btn-default px-4 text-uppercase fw-bold"
                  onClick={hide}
                >
                  CLOSE
                </button>
                <button
                  type="button"
                  className="btn btn-teal btn-default text-white px-5 ms-3 text-uppercase fw-bold"
                  onClick={hide}
                >
                  SAVE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isShowing && <div className="modal-backdrop fade show"></div>}
      
      {/* Custom styles just for this modal to ensure borders apply correctly on md+ screens */}
      <style>{`
        @media (min-width: 768px) {
          .border-end-md {
            border-right: 1px solid #e9ecef !important;
          }
        }
      `}</style>
    </>
  );
};

export default SupportHcpEnterBaselineDataModal;
